module.exports = __webpack_public_path__ + "static/media/tools.ccbe67ab.svg";